import { HeadingH1, HeadingH4 } from '@dreamstack/feature-components'
import type { FullBlockTableFragment } from '@dreamstack/investors-graphql'
import head from 'lodash/head'
import map from 'lodash/map'
import tail from 'lodash/tail'
import type { FunctionComponent } from 'react'
import tw, { styled } from 'twin.macro'

const StyledTr = styled.tr<{ isEven: boolean }>(({ isEven }) => [
  isEven ? tw`bg-accentroWhite-full` : tw`bg-accentroGray-50`,
  tw`py-px-32 align-middle`,
])

const StyledTd = styled.td(() => [tw`px-px-8 py-px-24 text-left md:(p-px-24)`])

export const TableGreyWhiteAlternating: FunctionComponent<React.PropsWithChildren<{
  block: FullBlockTableFragment
}>> = ({ block }) => {
  const { table, title } = block
  const headData: string[] | undefined = head(table?.tableData)
  const rowData: string[][] = tail(table?.tableData) || [[]]
  return (
    //TODO: how to give different width to the first column?
    (<div tw="w-full mt-px-48 md:(mt-px-80)">
      {title && <HeadingH1 tw="mb-px-24">{title}</HeadingH1>}
      <div tw="w-full overflow-auto">
        <table tw="w-full ">
          <thead>
            <tr tw="border-b border-accentroGray-full ">
              {map(headData, (headDataEntry, i) => (
                <th
                  tw="px-px-8 py-px-24 text-left mx-px-12 md:(p-px-24)"
                  key={i}
                >
                  <HeadingH4>{headDataEntry}</HeadingH4>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {map(rowData, (rowEntry, idx) => {
              const isEven = idx % 2 === 0
              return (
                <StyledTr key={idx} isEven={isEven}>
                  {map(rowEntry, (rowEntryData, i) => (
                    <StyledTd key={`rowdataentry${i}`}>
                      <HeadingH4 style={{ fontWeight: 'normal' }}>
                        {rowEntryData}
                      </HeadingH4>
                    </StyledTd>
                  ))}
                </StyledTr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>)
  );
}
